import { render, staticRenderFns } from "./person-type.vue?vue&type=template&id=42ce0c0c&scoped=true&"
import script from "./person-type.vue?vue&type=script&lang=js&"
export * from "./person-type.vue?vue&type=script&lang=js&"
import style0 from "./person-type.vue?vue&type=style&index=0&id=42ce0c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ce0c0c",
  null
  
)

export default component.exports